/***
 * clearProductsModel - Clears the current product model list
 */
var clearProductsModel = function () {
    this.productsModel.splice(0, this.productsModel.length);
};
/***
 * populateProductsModel - Adds to the product list
 * @param newProductList - array of products to add
 */
var populateProductsModel = function (newProductList) {
    for (var x = 0; x < newProductList.length; x++) {
        this.productsModel.push(newProductList[x]);
    }
};
var recommendedProductRequestModel = /** @class */ (function () {
    function recommendedProductRequestModel(searchTerm, $http, $q, $window, CommonDataService) {
        this.searchTerm = searchTerm;
        this.requestStates = {
            NOT_STARTED: 'NOT_STARTED',
            IN_PROGRESS: 'IN_PROGRESS',
            COMPLETED_SUCCESS: 'COMPLETED_SUCCESS',
            COMPLETED_ERROR: 'COMPLETED_ERROR'
        };
        this.requestStateModel = {
            active: false,
            promise: null,
            state: this.requestStates.NOT_STARTED
        };
        this.productsModel = [];
        this.$http = $http;
        this.$window = $window;
        this.$q = $q;
        this.CommonDataService = CommonDataService;
    }
    /***
     * refresh - get the recommended products
     */
    recommendedProductRequestModel.prototype.refresh = function () {
        var _this = this;
        //If request has already been successful or is already going just return the promise for the currently going request
        if (this.requestStateModel.state === this.requestStates.COMPLETED_SUCCESS || this.requestStateModel.state === this.requestStates.IN_PROGRESS) {
            return this.requestStateModel.promise;
        }
        this.requestStateModel.state = this.requestStates.IN_PROGRESS;
        this.requestStateModel.active = true;
        var deferred = this.$q.defer();
        //keep a reference to the promise so anyone can listen on it
        this.requestStateModel.promise = deferred.promise;
        var request = this.$http({
            method: 'POST',
            url: 'api/typeahead/search/' + this.$window.encodeURIComponent(this.searchTerm)
        });
        request
            .then(function (results) {
            if (results.data.errors.length > 0) {
                _this.requestStateModel.state = _this.requestStates.COMPLETED_ERROR;
                return deferred.reject(results.data.errors[0]);
            }
            clearProductsModel.call(_this);
            populateProductsModel.call(_this, results.data.response);
            _this.requestStateModel.state = _this.requestStates.COMPLETED_SUCCESS;
            _this.CommonDataService.addAttributeProductPathsForAllItems(results.data.response);
            return deferred.resolve(results.data.response);
        })
            .catch(function (error) {
            _this.requestStateModel.state = _this.requestStates.COMPLETED_ERROR;
            return deferred.reject(error);
        })
            .finally(function () {
            //always set the active to false no matter how we resolve
            _this.requestStateModel.active = false;
        });
        return deferred.promise;
    };
    ;
    return recommendedProductRequestModel;
}());
export default recommendedProductRequestModel;
//# sourceMappingURL=recommended-products-request.model.js.map